import { render, staticRenderFns } from "./GPathAptitudeAdd.vue?vue&type=template&id=69b1335e&scoped=true"
import script from "./GPathAptitudeAdd.vue?vue&type=script&lang=js"
export * from "./GPathAptitudeAdd.vue?vue&type=script&lang=js"
import style0 from "./GPathAptitudeAdd.vue?vue&type=style&index=0&id=69b1335e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b1335e",
  null
  
)

export default component.exports